<div class="student-card navi-card p-3 p-md-4" *ngIf="hasRoute()">

  <div class="d-flex align-items-start justify-content-between mb-2">
    <div>
      <p class="fs-20 fw-800 color-gray-950 mb-0">{{'students.navi_route.title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="nextLevelName()">
        {{'students.navi_route.next_stop'|translate}}
        <span class="fw-800 color-level-primary" [class]="'level-' + steps[activeIndex + 1].levelKey">
          {{'students.navi_route.level_name'|translate: {level: nextLevelName()} }}
        </span>
      </p>
      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!nextLevelName()">
        {{'students.navi_route.top_level'|translate}}
      </p>
    </div>

    <span class="level-badge fs-small fw-800" [class]="'level-' + steps[activeIndex].levelKey">
      {{'students.navi_route.level_name'|translate: {level: currentLevelName()} }} · %{{progressToNext}}
    </span>
  </div>

  <app-navi-route-map
    [steps]="steps" [activeIndex]="activeIndex" [progressToNext]="progressToNext"
    [marker]="marker" [ariaLabel]="'students.navi_route.title'|translate"></app-navi-route-map>

</div>
